import { Modal, Button } from '@dev-spendesk/grapes';
import { useDispatch } from 'react-redux';

import { LocalStorageKey } from 'src/core/constants/storage';
import { getLocalItem } from 'src/core/utils/storage';
import { logger } from 'src/utils/datadog-log-wrapper';

import { hideSwitchedSupervisedUserModal } from './redux/actions';

export const SwitchedSupervisedUserModal = () => {
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    logger.info('SwitchedSupervisedUserModal click reload', {
      team: 'travel-and-expenses',
      scope: 'auth::reload',
    });
    window.location.reload();
  };

  const newSupervisedUserName = getLocalItem(
    LocalStorageKey.LastSupervisedUserName,
    true,
  );

  const handleClose = () => {
    dispatch(hideSwitchedSupervisedUserModal());
  };

  return (
    <Modal
      isOpen
      iconName="arrow-path"
      title={`You just switched to the supervision account of ${newSupervisedUserName}`}
      onClose={handleClose}
      subtitle="Please reload the page to update"
      actions={<Button text="Reload" onClick={handleButtonClick} />}
    />
  );
};
